export const SUPPORTED = ['en', 'de', 'es', 'fr', 'it', 'pt', 'sr', 'nl', 'ja', 'pl'];
export const defaultLang = 'en';
